import createHttpClient from '../../axios/createHttpClient';
import { addEntities } from '../../../redux/reducers/entities';

const httpClient = createHttpClient();

// activityGroups
export const getActivityGroupList = (clientToken, clubId, config = {}) => (dispatch, getState) => {
  const sendRequest = httpClient.get(`${clientToken}/clubs/${clubId}/activitygroups`, config).then(results => {
    dispatch(addEntities('activityGroups', results.data));
    return results;
  });

  return sendRequest;
};

// activity
export const getActivityList = (clientToken, clubId, config = {}) => (dispatch, getState) => {
  const sendRequest = httpClient.get(`${clientToken}/clubs/${clubId}/activities`, config).then(results => {
    dispatch(addEntities('activities', results.data));
    return results;
  });

  return sendRequest;
};



// WEBPACK FOOTER //
// ./src/http-client/endpoints/activityApi/index.js